import * as chefCoordinators from './chef'
import * as chefDataCoordinators from './chefData'
import * as conceptCoordinators from './concept'
import * as menuItemModsCoordinators from './menuItemMods'
import * as menuItemCoordinators from './menuItem'
import * as recipeCoordinators from './recipe'
import * as scheduleCoordinators from './schedule'
import * as serviceItemCoordinators from './serviceItem'
import * as snackPackCoordinators from './snackPack'
import * as suggestionCoordinators from './suggestion'
import * as virtualItemCoordinators from './virtualItem'
import * as virtualKitCoordinators from './virtualKit'
import * as hubspotCoordinators from './hubspot'

export default Object.freeze({
  ...chefCoordinators,
  ...chefDataCoordinators,
  ...conceptCoordinators,
  ...menuItemModsCoordinators,
  ...menuItemCoordinators,
  ...recipeCoordinators,
  ...scheduleCoordinators,
  ...serviceItemCoordinators,
  ...snackPackCoordinators,
  ...suggestionCoordinators,
  ...virtualItemCoordinators,
  ...virtualKitCoordinators,
  ...hubspotCoordinators,
})
